import classnames from "classnames"
import { EllipsisOutlined, LeftOutlined, RightOutlined } from "./icons"
import { translate } from "../app"
import { translations } from "../translations"

interface Props {
  className?: string
  current: number
  pageSize: number
  total: number
  onChange?(page: number, pageSize?: number): void
}

function range(size: number) {
  return [...Array(size).keys()].map(i => i + 1)
}

function PageNumber(props: { page: number, current: number, onClick: (page: number) => void }) {
  const { page, current, onClick } = props
  if (page == current)
    return <button type="button" aria-current="page" className="pagination__page pagination__page--active">{page}</button>
  return <button type="button" className="pagination__page" onClick={() => onClick?.(page)}>{page}</button>
}

const VISIBLE_ITEMS = 5

export function Pagination(props: Props) {

  const { current, pageSize, total, onChange } = props
  let pages = []

  let startPage = 2
  let overflowLeft = false
  let overflowRight = false
  let onePage = false
  let endPage = 0
  const totalPages = Math.ceil(total / pageSize)


  if (current > (VISIBLE_ITEMS - 1)) {
    overflowLeft = true
    startPage = (current - VISIBLE_ITEMS) + 3
  }
  if (current - VISIBLE_ITEMS >= 2) {
    overflowLeft = true
  }
  if (startPage > 2) {
    overflowLeft = true
  }

  const rLimitOverflow = current + VISIBLE_ITEMS - 2
  if (rLimitOverflow < totalPages) {
    overflowRight = true
  }

  for (let i = 0; i < VISIBLE_ITEMS; i++) {
    if (startPage + i + 1 > totalPages) break
    endPage = startPage + i
    pages.push(endPage)
  }

  if (totalPages == 1) {
    pages = []
    onePage = true
  }


  // if (endPage + 1 >= totalPages) {
  //   overflowLeft = false
  //   overflowRight = false
  // }


  function onPageChange(page: number) {
    if (page <= 0) page = 1
    if (page >= totalPages) page = totalPages
    onChange?.(page, pageSize)
  }

  return <nav aria-label={translate(translations.pagination)} className={classnames("pagination", props.className)}>
    <button type="button" aria-label={translate(translations.previous)} disabled={current <= 1} className="pagination__arrow" onClick={() => onPageChange(current - 1)}>
      <LeftOutlined aria-hidden="true" />
    </button>
    <PageNumber page={1} current={current} onClick={onPageChange} />
    {overflowLeft && <span className="pagination__ellipsis" aria-hidden="true"><EllipsisOutlined /></span>}
    {pages.map(page => {
      return <PageNumber key={page} page={page} current={current} onClick={onPageChange} />
    })}
    {overflowRight && <span className="pagination__ellipsis" aria-hidden="true"><EllipsisOutlined /></span>}
    {!onePage && <PageNumber page={totalPages} current={current} onClick={onPageChange} />}
    <button type="button" aria-label={translate(translations.next)} disabled={current >= totalPages} className="pagination__arrow" onClick={() => onPageChange(current + 1)}>
      <RightOutlined aria-hidden="true" />
    </button>
  </nav>

}

